export type HomeCopy = {
  navFeatures: string;
  navRoles: string;
  navPricing: string;
  navAbout: string;
  navBlog: string;
  navHelp: string;
  navContact: string;
  navLogin: string;
  navCta: string;
  heroTitleBefore: string;
  heroTitleAfter: string;
  heroSub: string;
  heroCta: string;
  heroDemo: string;
  heroNote: string;
  logosLabel: string;
  roleEyebrow: string;
  roleTitle: string;
  roleOwner: string;
  roleManager: string;
  roleEmployee: string;
  ownerFeat1Title: string;
  ownerFeat1Desc: string;
  ownerFeat2Title: string;
  ownerFeat2Desc: string;
  ownerFeat3Title: string;
  ownerFeat3Desc: string;
  managerFeat1Title: string;
  managerFeat1Desc: string;
  managerFeat2Title: string;
  managerFeat2Desc: string;
  managerFeat3Title: string;
  managerFeat3Desc: string;
  employeeFeat1Title: string;
  employeeFeat1Desc: string;
  employeeFeat2Title: string;
  employeeFeat2Desc: string;
  employeeFeat3Title: string;
  employeeFeat3Desc: string;
  featEyebrow: string;
  featTitle: string;
  tourEyebrow: string;
  tourTitle: string;
  tourSub: string;
  reviewsTitle: string;
  pricingTitle: string;
  pricingSub: string;
  pricingMonthly: string;
  pricingYearly: string;
  pricingSave: string;
  mobileEyebrow: string;
  mobileTitle: string;
  mobileSub: string;
  contactEyebrow: string;
  contactTitle: string;
  contactSub: string;
  contactSubmit: string;
  contactConsent: string;
  ctaTitle: string;
  ctaSub: string;
  ctaButton: string;
  ctaNote: string;
  footerTagline: string;
};

const CS: HomeCopy = {
  navFeatures: 'Funkce',
  navRoles: 'Pro koho',
  navPricing: 'Ceník',
  navAbout: 'O nás',
  navBlog: 'Blog',
  navHelp: 'Nápověda',
  navContact: 'Kontakt',
  navLogin: 'Přihlásit se',
  navCta: 'Vyzkoušet zdarma',
  heroTitleBefore: 'Chytrý tým,',
  heroTitleAfter: 'bez chaosu',
  heroSub: 'Ompli spojuje směny, docházku, smlouvy i nábor do jedné aplikace - na počítači i v mobilu.',
  heroCta: 'Vyzkoušet zdarma',
  heroDemo: 'Vyzkoušet demo',
  heroNote: 'Bez platební karty · Nastavení za 5 minut',
  logosLabel: 'Důvěřují nám firmy jako',
  roleEyebrow: 'Jedna appka, tři pohledy',
  roleTitle: 'Pro majitele, manažera i zaměstnance - jedna appka',
  roleOwner: 'Majitel',
  roleManager: 'Manažer',
  roleEmployee: 'Zaměstnanec',
  ownerFeat1Title: 'Reporty a náklady',
  ownerFeat1Desc: 'Hodiny, obsazenost i náklady na směny v jednom přehledu.',
  ownerFeat2Title: 'Smlouvy bez papírování',
  ownerFeat2Desc: 'DPP, DPČ i HPP k podpisu online včetně archivu PDF.',
  ownerFeat3Title: 'Celá firma pod kontrolou',
  ownerFeat3Desc: 'Pobočky, pozice, manažeři a práva na jednom místě.',
  managerFeat1Title: 'Plánování směn',
  managerFeat1Desc: 'Drag-and-drop rozvrh, šablony a schvalování přihlášení.',
  managerFeat2Title: 'Schvalování docházky',
  managerFeat2Desc: 'Příchody, odchody a žádosti o volno vyřešíte za minuty.',
  managerFeat3Title: 'Tým na dosah',
  managerFeat3Desc: 'Zprávy a oznámení přímo v aplikaci, bez skupinových chatů.',
  employeeFeat1Title: 'Check-in jedním klikem',
  employeeFeat1Desc: 'Příchod i odchod přímo z mobilu, i offline.',
  employeeFeat2Title: 'Výměny směn v chatu',
  employeeFeat2Desc: 'Domluva s kolegou a schválení manažerem na pár kliků.',
  employeeFeat3Title: 'Směny a výdělek',
  employeeFeat3Desc: 'Rozvrh, odpracované hodiny a výdělek vždy po ruce.',
  featEyebrow: 'Funkce',
  featTitle: 'Vše, co potřebujete k řízení týmu',
  tourEyebrow: 'Tři kroky k rozjezdu',
  tourTitle: 'Pozvěte tým, naplánujte, hlídejte hodiny',
  tourSub: 'Od pozvánky pro zaměstnance přes hotový rozvrh až po docházku v reálném čase - všechno v jedné aplikaci, bez tabulek a papírů.',
  reviewsTitle: 'Firmy, které si zjednodušily práci',
  pricingTitle: 'Ceník, který dává smysl',
  pricingSub: 'Free do 5 lidí, dál platíte jen za aktivní zaměstnance. Bez skrytých poplatků.',
  pricingMonthly: 'Měsíčně',
  pricingYearly: 'Ročně',
  pricingSave: 'Ušetříte 20 %',
  mobileEyebrow: 'Mobilní aplikace',
  mobileTitle: 'Tým má směny v kapse',
  mobileSub: 'Zaměstnanci vidí rozvrh, zapíšou docházku, domluví výměnu směny nebo se přihlásí na novou práci - kdykoli a odkudkoli.',
  contactEyebrow: 'Kontakt',
  contactTitle: 'Pojďme se potkat',
  contactSub: 'Vyberte si termín v kalendáři, nebo nám napište - ozveme se do jednoho pracovního dne.',
  contactSubmit: 'Odeslat zprávu',
  contactConsent: 'Odesláním souhlasíte se zpracováním údajů pro účely kontaktování.',
  ctaTitle: 'Zjednodušte si řízení týmu ještě dnes',
  ctaSub: 'Založte firmu v Ompli a naplánujte první týden směn za pár minut.',
  ctaButton: 'Vyzkoušet zdarma',
  ctaNote: 'Bez platební karty · Zrušit můžete kdykoli',
  footerTagline: 'Směny, docházka, smlouvy a nábor v jedné aplikaci pro rostoucí firmy.',
};

const EN: HomeCopy = {
  navFeatures: 'Features',
  navRoles: 'Who it’s for',
  navPricing: 'Pricing',
  navAbout: 'About',
  navBlog: 'Blog',
  navHelp: 'Help',
  navContact: 'Contact',
  navLogin: 'Sign in',
  navCta: 'Try for free',
  heroTitleBefore: 'Smart team,',
  heroTitleAfter: 'without chaos',
  heroSub: 'Ompli brings shifts, attendance, contracts, and hiring into one app - on desktop and mobile.',
  heroCta: 'Try for free',
  heroDemo: 'Try the demo',
  heroNote: 'No credit card · Set up in 5 minutes',
  logosLabel: 'Trusted by teams like',
  roleEyebrow: 'One app, three views',
  roleTitle: 'For owners, managers, and employees - one app',
  roleOwner: 'Owner',
  roleManager: 'Manager',
  roleEmployee: 'Employee',
  ownerFeat1Title: 'Reports & costs',
  ownerFeat1Desc: 'Hours, fill rate, and shift costs in one dashboard.',
  ownerFeat2Title: 'Paperless contracts',
  ownerFeat2Desc: 'Sign employment contracts online with a PDF archive.',
  ownerFeat3Title: 'Whole company in control',
  ownerFeat3Desc: 'Locations, positions, managers, and permissions in one place.',
  managerFeat1Title: 'Shift scheduling',
  managerFeat1Desc: 'Drag-and-drop roster, templates, and signup approvals.',
  managerFeat2Title: 'Attendance approvals',
  managerFeat2Desc: 'Clock-ins, clock-outs, and leave requests in minutes.',
  managerFeat3Title: 'Team within reach',
  managerFeat3Desc: 'Messages and announcements in the app - no group chats needed.',
  employeeFeat1Title: 'One-tap check-in',
  employeeFeat1Desc: 'Clock in and out from mobile, even offline.',
  employeeFeat2Title: 'Shift swaps in chat',
  employeeFeat2Desc: 'Agree with a colleague and get manager approval in a few taps.',
  employeeFeat3Title: 'Shifts & earnings',
  employeeFeat3Desc: 'Schedule, worked hours, and pay always at hand.',
  featEyebrow: 'Features',
  featTitle: 'Everything you need to run your team',
  tourEyebrow: 'Three steps to launch',
  tourTitle: 'Invite the team, schedule, track hours',
  tourSub: 'From employee invites through a finished schedule to live attendance - all in one app, without spreadsheets and paper.',
  reviewsTitle: 'Companies that simplified their work',
  pricingTitle: 'Pricing that makes sense',
  pricingSub: 'Free for up to 5 people, then pay only for active employees. No hidden fees.',
  pricingMonthly: 'Monthly',
  pricingYearly: 'Yearly',
  pricingSave: 'Save 20%',
  mobileEyebrow: 'Mobile app',
  mobileTitle: 'Shifts in your pocket',
  mobileSub: 'Employees see the schedule, clock in, swap shifts, or apply for new work - anytime, anywhere.',
  contactEyebrow: 'Contact',
  contactTitle: 'Let’s meet',
  contactSub: 'Pick a time on the calendar, or write to us - we reply within one business day.',
  contactSubmit: 'Send message',
  contactConsent: 'By submitting you agree to processing of your data for contact purposes.',
  ctaTitle: 'Simplify team management today',
  ctaSub: 'Create your company in Ompli and plan the first week of shifts in minutes.',
  ctaButton: 'Try for free',
  ctaNote: 'No credit card · Cancel anytime',
  footerTagline: 'Shifts, attendance, contracts, and hiring in one app for growing companies.',
};

export function getHomeCopy(lang: 'cs' | 'en'): HomeCopy {
  return lang === 'en' ? EN : CS;
}
